<template>
  <div class="wrapper">
    个人中心
  </div>
</template>

<script>
export default {
  data(){
    return{
      
    }
  },
  methods: {
    
  },
}
</script>

<style lang="less" scoped>
.wrapper{
  width: 100%;
  height: 100%;
  overflow: auto;
  background: #f8f8f8;
}
</style>



// WEBPACK FOOTER //
// src/views/user/user.vue